import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import RankrHero from '@/components/rankr/RankrHero';
import RankrHow from '@/components/rankr/RankrHow';
import RankrFeatures from '@/components/rankr/RankrFeatures';
import RankrGuarantee from '@/components/rankr/RankrGuarantee';
import RankrPricing from '@/components/rankr/RankrPricing';
import RankrFaq from '@/components/rankr/RankrFaq';
import LeadForm from '@/components/LeadForm';
import CalendlySection from '@/components/CalendlySection';

export default function Rankr() {
  useEffect(() => {
    document.title = 'Rankr | SEO, Done For You — Ahana Digital Agency';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Rank #1 on Google and ChatGPT. Daily content, technical SEO and real engineers running it for you. 90-day money-back guarantee.');
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <RankrHero />
      <RankrHow />
      <RankrFeatures />
      <RankrGuarantee />
      <RankrPricing />
      <section id="rankr-start" className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Get Started</p>
            <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight">
              Send us your website. We will handle the rest.
            </h2>
            <p className="mt-5 text-white/55 font-light leading-relaxed max-w-lg">
              An engineer will review your site, confirm your 90-day growth plan and get you live — no technical knowledge needed.
            </p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-8">
            <LeadForm type="rankr" buttonLabel="Start Ranking" showAdSpend={false} showMessage redirectTo="/thank-you" />
          </div>
        </div>
      </section>
      <RankrFaq />
      <CalendlySection />
      <Footer />
    </div>
  );
}